import MojitoPresentation from 'mojito/presentation';
const IntentTypes = MojitoPresentation.Base.Intent.Types;
const { NavigationPathBuilder } = MojitoPresentation.Base.Navigation;

export default class MyAccountMenuItemDescriptors {
    /**
     * Retrieves the intent associated with the specified item id.
     *
     * @param {string} itemId - The item id to search for.
     *
     * @returns {object} Returns the corresponding intent if found, otherwise undefined.
     * @function Mojito.Modules.MyAccountMenuItemDescriptors#getIntentFromItemId
     */
    static getIntentFromItemId(itemId) {
        const item = this._findItem(itemId);

        return item ? item.intent : undefined;
    }

    static _findItem(itemId) {
        return Object.values(MyAccountMenuItemDescriptors.ITEMS).find(
            itemDescriptor => itemDescriptor.ID === itemId
        );
    }
}

MyAccountMenuItemDescriptors.ITEMS = {
    BONUSES: {
        ID: 'bonuses',
        intent: {
            type: IntentTypes.VIEW,
            data: NavigationPathBuilder.toAccount('bonuses'),
        },
    },
    ACTIVE_BONUSES: {
        ID: 'active-bonuses',
        intent: {
            type: IntentTypes.VIEW,
            data: NavigationPathBuilder.toAccount('bonuses', 'active-bonuses'),
        },
    },
    IN_PROGRESS_BONUSES: {
        ID: 'in-progress-bonuses',
        intent: {
            type: IntentTypes.VIEW,
            data: NavigationPathBuilder.toAccount('bonuses', 'in-progress-bonuses'),
        },
    },
    BONUS_HISTORY: {
        ID: 'bonus-history',
        intent: {
            type: IntentTypes.VIEW,
            data: NavigationPathBuilder.toAccount('bonuses', 'bonus-history'),
        },
    },
    PASSWORD: {
        ID: 'password',
        intent: {
            type: IntentTypes.VIEW,
            data: NavigationPathBuilder.toAccount('password'),
        },
    },
    BET_HISTORY: {
        ID: 'bet-history',
        intent: {
            type: IntentTypes.VIEW,
            data: NavigationPathBuilder.toAccount('bet-history'),
        },
    },
    BET_HISTORY_DETAILS: {
        ID: 'bet-history-details',
    },
    APP_SETTINGS: {
        ID: 'app-settings',
        intent: {
            type: IntentTypes.APP_SETTINGS,
        },
    },
};
